import React, { useContext, useState, useEffect, useRef } from 'react';
import ReactSVG from 'react-svg';
import minus from 'minus.svg';
import plus from 'plus.svg';
import { ListingMapContext } from '../../../context/ListingMapContext';
import WindowQuery from '../../../utils/WindowQuery';
import useOutsideClick from '../../../hooks/useOutsideClick';

export default function GuestsDropdown() {
  const updateQuery = new WindowQuery();
  const dropdownRef = useRef();

  const MIN_GUESTS = 0;
  const MAX_GUESTS = 25;

  const [localGuests, setLocalGuests] = useState(MIN_GUESTS);

  const { setGuests, setDropdown, guests, guestsVisible } = useContext(
    ListingMapContext
  );

  useEffect(() => {
    if (guests) setLocalGuests(guests);
  }, [guests]);

  useOutsideClick(dropdownRef, guestsVisible, () => setDropdown(null));

  return (
    <div ref={dropdownRef} className="dropdown-wrapper guests mobile">
      <h2 className="dropdown-title">Number of Guests</h2>
      <button
        aria-label="Clear Guests Filter"
        name="Clear Guests Filter"
        type="button"
        onClick={() => {
          setLocalGuests(guests);
          setDropdown(null);
        }}
        className="mobile-dropdown-cancel btn btn--small"
      >
        Close
      </button>

      <section className="dropdown-guests-container">
        <button
          aria-label="Subtract Guests"
          name="Subtract Guests"
          type="button"
          className={`btn btn--round subtract ${
            localGuests === MIN_GUESTS ? 'disabled' : ''
          }`}
          onClick={() => setLocalGuests(Math.max(localGuests - 1, MIN_GUESTS))}
        >
          <ReactSVG src={minus} />
        </button>
        <h3>{localGuests}</h3>
        <button
          aria-label="Add Guests"
          name="Add Guests"
          type="button"
          className={`btn btn--round add ${
            localGuests === MAX_GUESTS ? 'disabled' : ''
          }`}
          onClick={() => setLocalGuests(Math.min(localGuests + 1, MAX_GUESTS))}
        >
          <ReactSVG src={plus} />
        </button>
      </section>

      <section className="dropdown-apply">
        <button
          aria-label="Apply Guests Filter"
          name="Apply Guests Filter"
          type="button"
          className="btn btn--dark btn--small apply"
          onClick={() => {
            setGuests(localGuests);
            setDropdown(null);
            updateQuery.add('guests', localGuests);
          }}
        >
          Apply
        </button>
        <button
          aria-label="Clear Guests Filter"
          name="Clear Guests Filter"
          type="button"
          className="btn btn--small clear-filter"
          onClick={() => {
            setLocalGuests(MIN_GUESTS);
            setGuests(MIN_GUESTS);
            updateQuery.remove('guests');
          }}
        >
          Clear
        </button>
      </section>
    </div>
  );
}
